



















































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ListBase from '@/lib/listbase';
import Util from '@/lib/util';
import ApexCharts from 'apexcharts'
import VueApexCharts from 'vue-apexcharts'

@Component({
    components: { apexcharts: VueApexCharts },
})

export default class CemIndicators extends ListBase {
    @Prop({ type: Object }) pagerequest: object;
    series1: Array<number> = [20, 20, 20, 20, 20];
    series2: Array<number> = [20, 20, 20];
    series3: Array<number> = [100];
    options1: any = {
        chart: {
            width: 300,
            type: 'pie',
        },
        legend: {
            fontSize: "10px"
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: "10px",
            }
        },
        labels: ['A', 'B', 'C', 'D', 'E'],
        title: {
            text: "Modelos Atendidos",
            align: 'center',
            style: {
                fontSize: '12px',
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    };
    options2: any = {
        chart: {
            width: 300,
            type: 'pie',
        },
        legend: {
            fontSize: "10px"
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: "10px",
            }
        },
        labels: ['Segmento 1', 'Segmento 2', 'Segmento 3'],
        title: {
            text: "Segmento Atendido",
            align: 'center',
            style: {
                fontSize: '12px',
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    };
    options3: any = {
        chart: {
            width: 300,
            type: 'pie',
        },
        legend: {
            fontSize: "10px"
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: "10px",
            }
        },
        labels: ['A'],
        title: {
            text: "Tipo Servicio",
            align: 'center',
            style: {
                fontSize: '12px',
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    };

    get rate() {
        return this.$store.state.sale.rate;
    }

    get loading() {
        return this.$store.state.sale.loadingInds;
    }

    async loadData() {
        await this.$store.dispatch({
            type: 'sale/getIndicators',
            data: this.pagerequest
        });          

        this.series1 = this.$store.state.sale.series1;
        this.series2 = this.$store.state.sale.series2;
        this.series3 = this.$store.state.sale.series3;

        this.options1 = {
            labels: this.$store.state.sale.categories1
        }

        this.options2 = {
            labels: this.$store.state.sale.categories2
        }

        this.options3 = {
            labels: this.$store.state.sale.categories3
        }
    }

    mounted() { 
        this.loadData();
    }
}
